if (!customElements.get('trg-announcement-carousel')) {
  customElements.define('trg-announcement-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('[data-announcement-slide]')];
      this.toggle = this.querySelector('[data-announcement-toggle]');
      this.messages = this.querySelector('.trg-announcement__messages');
      if (this.slides.length < 2 || !this.toggle) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.hovered = false;
      this.focused = false;
      this.index = 0;
      this.querySelectorAll('button').forEach(button => { button.disabled = false; });
      this.querySelector('[data-announcement-previous]').addEventListener('click', () => this.move(-1), options);
      this.querySelector('[data-announcement-next]').addEventListener('click', () => this.move(1), options);
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.focused = false;
        this.updateToggle();
        this.schedule();
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.stop(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.stop(); }, options);
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) { this.paused = true; this.updateToggle(); }
        this.schedule();
      }, options);
      this.show(0);
      this.updateToggle();
      this.schedule();
    }

    disconnectedCallback() {
      this.stop();
      this.controller?.abort();
    }

    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
    }

    move(direction) {
      this.paused = true;
      this.show(this.index + direction);
      this.updateToggle();
      this.schedule();
    }

    updateToggle() {
      const label = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
      this.toggle.setAttribute('aria-label', label);
      this.toggle.title = label;
      this.querySelector('[data-announcement-pause]').toggleAttribute('hidden', this.paused);
      this.querySelector('[data-announcement-play]').toggleAttribute('hidden', !this.paused);
      this.messages.setAttribute('aria-live', this.paused ? 'polite' : 'off');
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    schedule() {
      this.stop();
      if (this.paused || this.hovered || this.focused || document.hidden) return;
      this.timer = setInterval(() => this.show(this.index + 1), 6000);
    }
  });
}
